export const BoxCompleta = props =>{
    return <div className="boxEffectCompleta">
    <div className="leftline line"></div>
    <div className="rightline line"></div>
    <div className="topline line"></div>
    <div className="bottomline line"></div>
    <div className="half-circle"></div>
    <div className="menuBtn" onClick={()=>props.lateralMenu.current.showLateralMenu(true)}>
      <div className="insideMenucircleBtn">Menu</div></div>
  </div> 
}

export default BoxCompleta